/**
 * Utilities for SKU autocomplete search.
 *
 * Extracted from ProductAddEditForm.vue for testability.
 * See: #425 (isCancel crash), #426 (full label as query)
 */

/**
 * Check if an error is a request cancellation (AbortController or Axios cancel).
 *
 * In Vuetify 3, this.$axios.isCancel() doesn't exist on Axios instances —
 * isCancel is a static method on the module. We check err.name instead.
 *
 * @param {Error} err - The caught error
 * @returns {boolean} True if the error is a cancellation, not a real failure
 */
export function isRequestCancelled(err) {
  if (!err) return false;
  return err.name === "CanceledError" || err.name === "AbortError";
}

/**
 * Extract just the SKU from a combobox search query.
 *
 * On blur, Vuetify's v-combobox re-emits the display label ("SKU — Title")
 * as the search string. This extracts just the SKU prefix before the em-dash
 * separator to avoid sending the full title to the API.
 *
 * @param {*} query - The raw search query from the combobox
 * @returns {string} The cleaned SKU query, or empty string if invalid
 */
export function extractSkuFromQuery(query) {
  if (!query || typeof query !== "string") return "";
  const dashIdx = query.indexOf(" \u2014 ");
  return dashIdx > 0 ? query.substring(0, dashIdx).trim() : query.trim();
}
